import { REPORT_TYPES } from '@repo/constants'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/_modules/_app/reports/misc')({
  staticData: {
    title: REPORT_TYPES.MISC,
    crumb: REPORT_TYPES.MISC,
    permissions: ['reports_view_misc'],
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route)
  },
})
